module.exports = __webpack_public_path__ + "img/hotAndCode.e9b40e5d.svg";